module.exports = "/_next/static/images/footer-particle-87be5ce968ee2780fcecdbcfcb593b7b.png";